import type BaseMockQueryResolver from './BaseMockQueryResolver';
import Query from './Query';
import QueryResult from './QueryResult';

class QueryMockResolver {
  private resolvers: BaseMockQueryResolver[] = [];

  get isEmpty() {
    return this.resolvers.length === 0;
  }

  register(resolver: BaseMockQueryResolver) {
    if (!this.resolvers.includes(resolver)) {
      this.resolvers.push(resolver);
    }
  }

  unregister(resolver: BaseMockQueryResolver) {
    this.resolvers = this.resolvers.filter((registeredResolver) => registeredResolver !== resolver);
  }

  resolve<T>(query: Query): Nullable<QueryResult<T>> {
    for (const resolver of this.resolvers) {
      const result = resolver.resolve(query);

      if (result) {
        return result as QueryResult<T>;
      }
    }

    return null;
  }
}

export const queryMockResolver = new QueryMockResolver();
